import React from "react";
import { Offcanvas } from "react-bootstrap";
import { Link } from "react-router-dom";
// 1. Import the FontAwesomeIcon component
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
// 2. Import the specific icons you need
import { 
  faChartColumn, 
  faMobileScreenButton, 
  faGear, 
  faRightFromBracket 
} from "@fortawesome/free-solid-svg-icons";
import { 
  faPenToSquare, 
  faClipboard, 
  faCommentDots 
} from "@fortawesome/free-regular-svg-icons";

import "./ProfileOffcanvas.css";

export default function ProfileOffcanvas({
  showMenu,
  setShowMenu,
  jobSeekerData,
  logout,
}) {
  const firstInitial = jobSeekerData?.first_name
    ? jobSeekerData.first_name[0].toUpperCase()
    : "S";
  const lastInitial = jobSeekerData?.last_name
    ? jobSeekerData.last_name[0].toUpperCase()
    : "L";
  const fullName = jobSeekerData?.first_name
    ? `${jobSeekerData.first_name} ${jobSeekerData.last_name || ""}`
    : "Smita Lad";

  return (
    <Offcanvas
      show={showMenu}
      onHide={() => setShowMenu(false)}
      placement="end"
      className="profile-offcanvas-container"
    >
      <Offcanvas.Body className="profile-offcanvas-body">
        {/* Main Content Area */}
        <div className="profile-main-content">
          {/* Top Profile Card Group */}
          <div className="profile-card-group">
            
            {/* Header Profile Section */}
            <Link
              to="/view-profile"
              onClick={() => setShowMenu(false)}
            >
              <div className="profile-user-header">
                <div className="avatar-wrapper">
                  <div className="avatar-initials">
                    {firstInitial}
                    {lastInitial}
                  </div>
                  <span className="profile-score-badge">81%</span>
                </div>

                <div className="profile-user-details">
                  <h5 className="profile-user-name">{fullName}</h5>
                  <span className="improve-score-action">
                    <FontAwesomeIcon icon={faPenToSquare} /> Improve Profile Score
                  </span>
                </div>
              </div>
            </Link>

            {/* Main Navigation Links */}
            <div className="profile-internal-links">
              <Link
                to="/profile-performance"
                onClick={() => setShowMenu(false)}
                className="offcanvas-item"
              >
                <FontAwesomeIcon icon={faChartColumn} />
                <span>Profile Performance</span>
              </Link>

              <Link
                to="/career-services"
                onClick={() => setShowMenu(false)}
                className="offcanvas-item"
              >
                <FontAwesomeIcon icon={faClipboard} />
                <span>My Assessments</span>
              </Link>

              <Link
                to="/dashboardmain"
                onClick={() => setShowMenu(false)}
                className="offcanvas-item"
              >
                <FontAwesomeIcon icon={faMobileScreenButton} />
                <span>My Subscriptions</span>
              </Link>

              <Link
                to="/account"
                onClick={() => setShowMenu(false)}
                className="offcanvas-item"
              >
                <FontAwesomeIcon icon={faGear} />
                <span>Settings</span>
              </Link>
            </div>
          </div>

          {/* Secondary Actions */}
          <div className="profile-secondary-links">
            <Link
              to="/feedback"
              onClick={() => setShowMenu(false)}
              className="offcanvas-item"
            >
              <FontAwesomeIcon icon={faCommentDots} />
              <span>Feedback</span>
            </Link>
          </div>
        </div>

        {/* Bottom Logout Section */}
        <div className="profile-footer-section">
          <Link
            to="#"
            className="offcanvas-item logout-item"
            onClick={(e) => {
              e.preventDefault();
              if (logout) logout();
              setShowMenu(false);
            }}
          >
            <FontAwesomeIcon icon={faRightFromBracket} />
            <span>Logout</span>
          </Link>
        </div>
      </Offcanvas.Body>
    </Offcanvas>
  );
}